/* src/app/main/pages/contact/contact-banner/contact-banner.component.css */
.masthead {
  position: absolute;
  width: 100%;
}
h1 {
  color: #fff;
  font-size: 56px;
}
.sweden-link {
  position: absolute;
  top: 27%;
  right: 39%;
  width: 9%;
  text-align: center;
  opacity: 0;
  cursor: pointer;
  height: 35px;
}
.norway-link {
  position: absolute;
  top: 48%;
  right: 47%;
  width: 9%;
  text-align: center;
  opacity: 0;
  cursor: pointer;
  height: 35px;
}
.denmark-link {
  position: absolute;
  bottom: 12%;
  right: 47%;
  width: 9%;
  text-align: center;
  opacity: 0;
  cursor: pointer;
  height: 35px;
}
.finland-link {
  position: absolute;
  top: 43%;
  right: 27%;
  width: 9%;
  text-align: center;
  opacity: 0;
  cursor: pointer;
  height: 35px;
}
.estonia-link {
  position: absolute;
  top: 63%;
  right: 24.5%;
  width: 9%;
  text-align: center;
  opacity: 0;
  cursor: pointer;
  height: 35px;
}
@media (min-device-width: 1440px) {
  h1 {
    font-size: 89px;
  }
}
@media (min-device-width: 1200px) {
  h1 {
    padding-top: 110px;
  }
}
@media (max-device-width: 767px) {
  h1 {
    color: #fff;
    font-size: 28px;
  }
}
@media all and (-ms-high-contrast: none) {
  .ie-d-block {
    display: block !important;
  }
  h1 {
    position: absolute;
    z-index: 999;
    top: -240px;
    padding-top: 0px;
  }
}
/*# sourceMappingURL=contact-banner.component.css.map */
